import { merge, omit } from 'lodash/object';

import hmr from '../plugins/hmr';
import namedModules from '../plugins/namedModules';
import { MODES } from '../index';

const hmrPlugins = () => [hmr(), namedModules()];

export default (config, devServerConfig = config.devServer) => {
  if (!devServerConfig) {
    console.warn('Separate dev server config was not supplied, falling back to config.');
  }

  if (config.mode === MODES.production) {
    return omit(config, ['devServer']);
  }

  return merge(config, {
    devServer: devServerConfig,
    plugins: devServerConfig.hot ?
      [...config.plugins, ...hmrPlugins()] :
      config.plugins,
  });
};
